import { render, staticRenderFns } from "./BookingSettings.vue?vue&type=template&id=2575c1c7&scoped=true"
import script from "./BookingSettings.vue?vue&type=script&lang=js"
export * from "./BookingSettings.vue?vue&type=script&lang=js"
import style0 from "./BookingSettings.vue?vue&type=style&index=0&id=2575c1c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2575c1c7",
  null
  
)

export default component.exports